import { render } from "./GlyphloopPrivacy.vue?vue&type=template&id=f5745ff0&scoped=true"
import script from "./GlyphloopPrivacy.vue?vue&type=script&lang=js"
export * from "./GlyphloopPrivacy.vue?vue&type=script&lang=js"

import "./GlyphloopPrivacy.vue?vue&type=style&index=0&id=f5745ff0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5745ff0"]])

export default __exports__